<nb-card class="confirm-dlg">
  <form>
    <nb-card-body class="d-flex flex-column p-4">
      <h5 class="text-title">{{ textBody }}</h5>
      
      <div
        style="padding: 15px"
        class="cursor-pointer"
        fileDragDrop
        (filesChangeEmiter)="onFileDropped($event)"
        (click)="fileInput.click()"
      >
        <input
          #fileInput
          hidden
          type="file"
          id="fileDropRef"
          (change)="fileBrowseHandler($event)"
          (click)="fileInput.value='';"
        />
        <div class="d-flex align-items-center justify-content-center flex-column" style="user-select: none;">
          <label class="cursor-pointer">
            <nb-icon icon="attachment-icon" pack="mo-icons"></nb-icon>
          </label>
          <div class="mt-1 d-flex flex-column gap-1 align-items-center">
            <span class="textLink">Drag or browse your file here</span>
            <span class="subTitle">Supported format: {{ fileTypeAllowed }}</span>
          </div>
        </div>
      </div>
      
      <ng-container *ngIf="fileSelected">
        <div class="">
          <h6 class="m-0">{{fileSelected?.name}}</h6>
        </div>
      </ng-container>

      
      <div class="confirm-button d-flex flex-row justify-content-end mt-4">
        <button type="button" class="secondary mr-3"
          (click)="close()">{{ cancelText }}</button>
        <button type="submit" class="add small primary discard" (click)="onSubmit()" [disabled]="!fileSelected">{{ confirmText }}</button>
      </div>
    </nb-card-body>
  </form>
</nb-card>